import { __ } from '@wordpress/i18n';
import { RawHTML,useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, __experimentalUnitControl as UnitControl, RangeControl, __experimentalNumberControl as NumberControl, CheckboxControl, RadioControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        hfcPopupPadding,
        hfcPopupInnerWidth,
        hfcPopupBGcolor,
        hfcPopupBtncolor,
        hfcPopupBtnHovercolor,
        hfcPopupDelayTime,
        hfcShowOnScroll,
        hfcPopupTriggerType,
        hfcScrollHeightPercentage
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfc-popup-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const handlehfcPopupTriggerTypeChange = (value) => {
        const triggerType = value === 'false';
        setAttributes({ hfcPopupTriggerType: triggerType });
    };

    const handlehfcPopupDelayTimeChange = (value) => {
        const delayTime = parseInt(value, 10) || 0;
        setAttributes({ hfcPopupDelayTime: delayTime });
    };

    const handlehfcScrollHeightPercentageChange = (value) => {
        setAttributes({ hfcScrollHeightPercentage: parseInt(value, 10) || 50 });
    };

    useEffect(() => {
        const popupElement = document.getElementById(id);

        const showPopupOnScroll = () => {
            if (!popupElement) return;
            const scrollHeight = (document.documentElement.scrollTop || document.body.scrollTop) / (document.documentElement.scrollHeight || document.body.scrollHeight) * 100;
            if (scrollHeight >= hfcScrollHeightPercentage) {
                popupElement.classList.add('hfc-popup-visible');
            } else {
                popupElement.classList.remove('hfc-popup-visible');
            }
        };

        const showPopupOnDelay = () => {
            if (!popupElement) return;
            if (hfcPopupDelayTime > 0) {
                setTimeout(() => {
                    popupElement.classList.add('hfc-popup-visible');
                }, hfcPopupDelayTime);
            } else {
                popupElement.classList.add('hfc-popup-visible');
            }
        };

        if (hfcShowOnScroll && hfcPopupTriggerType) {
            window.addEventListener('scroll', showPopupOnScroll);
            return () => {
                window.removeEventListener('scroll', showPopupOnScroll);
            };
        } else if (!hfcPopupTriggerType) {
            showPopupOnDelay();
        }

        return () => {
            if (popupElement) {
                popupElement.classList.remove('hfc-popup-visible');
            }
        };
    }, [hfcShowOnScroll, hfcScrollHeightPercentage, hfcPopupTriggerType, hfcPopupDelayTime, id]);

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/media-text',
        'core/heading',
        'core/paragraph',
        'core/button'
    ];

    const TEMPLATE = [
        ['core/group', {
            className: 'hfc-popup-container',
        }, [
            ['core/media-text', {
                mediaType: 'image',
                mediaUrl: require('../public/img/offer.png'),
                imageFill: true,
                mediaAlt: 'black friday',
                className: 'hfc-popup-media-text'
            }, [
                ['core/paragraph', {
                    content: 'ONLY TODAY!',
                    align: 'left',
                    className: 'hfc-popup-title'
                }],
                ['core/heading', {
                    content: '30% OFF',
                    align: 'left',
                    className: 'hfc-popup-discount'
                }],
                ['core/paragraph', {
                    content: 'The key to victory is discipline, and that means a well made bed.',
                    align: 'left',
                    className: 'hfc-popup-description'
                }],
                ['core/button', {
                    text: 'Shop Now',
                    url: '#',
                    rel: 'nofollow',
                    className: 'hfc-popup-button'
                }]
            ]]
        ]]
    ];
    
    
    const hfcDynamicStyles = `
    /* Component styles */
    .frhd__component-width-90 .components-input-control__container {
        max-width: 100%;
    }
    .components-panel__body .components-base-control__label{
       font-size: 13px;
    }
    .components-panel__body .components-range-control__root,
    .components-panel__body  .components-radio-control{
        margin-top: 15px;
    }
    /* Theme Check */
    .editor-styles-wrapper .wp-block-hfc-blocks-pop-up,
    .editor-styles-wrapper .components-resizable-box__container{
        max-width: 100%!important;
    }
    .editor-styles-wrapper .wp-block-group__inner-container{
        padding: 0px;
    }
    #${id}.hfc-popup .hfc-popup-inner{
        position: relative;
        background-color: ${hfcPopupBGcolor};
        max-width: ${hfcPopupInnerWidth};
        width: 100%;
        margin: 0 auto;
        border-radius: 10px;
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
    }
    #${id}.hfc-popup .hfc-close-icon{
        position: absolute;
        top: -10px;
        right: -10px;
        background: #000;
        padding: 5px;
        border-radius: 100px;
        fill: #ffffff;
        z-index: 1;
        cursor: pointer;
    }
    #${id}.hfc-popup .wp-block-media-text__media{
        background-color: #f7f7f7;
        border-radius: 10px 0px 0px 10px;
        overflow: hidden;
    }
    #${id}.hfc-popup .wp-block-media-text__content{
        padding: 50px ${hfcPopupPadding}px;
    }
    #${id}.hfc-popup .wp-block-media-text__media img{
        object-fit: contain;
    }
    #${id}.hfc-popup .hfc-popup-columns{
       gap: 0px;
       margin: 0px;
    }
     #${id}.hfc-popup h2{
      font-weight: bold;
      margin: 0px;
      padding: 10px 0px;
      font-size: 60px;
    }
     #${id}.hfc-popup p{
      margin: 0px;
      font-size: 18px;
      color: #434343;
      line-height: 24px;
    }
    #${id}.hfc-popup .hfc-popup-button{
       margin: 0px;
       padding-top: 20px;
     }
    #${id}.hfc-popup .hfc-popup-button .wp-block-button__link{
       border-radius: 10px;
       color: #fff;
       background-color: ${hfcPopupBtncolor};
       font-size: 18px;
       padding: 15px 30px;
       line-height: 24px;
       transition: 0.4s;
     }
     #${id}.hfc-popup .hfc-popup-button .wp-block-button__link:hover{
       border-radius: 10px;
       background-color: ${hfcPopupBtnHovercolor};
     }
     /* Reponsive */
        @media (max-width: 599px) {
           #${id}.hfc-popup h2{
            font-size: 30px!important;
    }`;

    return (
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Popup Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
            >
                <Heading className={'frhd__pb-heading'}>Popup Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ hfcPopupPadding: newValue })}
                    isDragEnabled
                    value={hfcPopupPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Header Inner Width :')}
                    onChange={(newValue) => setAttributes({ hfcPopupInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={hfcPopupInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <Heading className={'frhd__pb-heading'}>Popup Background Color :</Heading>
                <ColorPalette
                    value={hfcPopupBGcolor}
                    onChange={(colorValue) => setAttributes({ hfcPopupBGcolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Popup Button Color :</Heading>
                <ColorPalette
                    value={hfcPopupBtncolor}
                    onChange={(colorValue) => setAttributes({ hfcPopupBtncolor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Popup Button Hover Color :</Heading>
                <ColorPalette
                    value={hfcPopupBtnHovercolor}
                    onChange={(colorValue) => setAttributes({ hfcPopupBtnHovercolor: colorValue })}
                    clearable={false}
                />
                <RadioControl
                    label="Popup Trigger Type : "
                    selected={hfcPopupTriggerType ? 'false' : 'true'}
                    options={[
                        { label: __('Scroll Trigger'), value: 'false' },
                        { label: __('Time Delay'), value: 'true' },
                    ]}
                    onChange={handlehfcPopupTriggerTypeChange}
                />
                {!hfcPopupTriggerType && (
                    <>
                        <Heading className={'frhd__pb-heading'}>Popup Delay Time (ms) :</Heading>
                        <NumberControl
                            onChange={handlehfcPopupDelayTimeChange}
                            value={hfcPopupDelayTime}
                        />
                    </>
                )}
                {hfcPopupTriggerType && (
                    <>
                        <CheckboxControl
                            label={__('Show on Scroll')}
                            checked={hfcShowOnScroll}
                            onChange={(value) => setAttributes({ hfcShowOnScroll: value })}
                            __nextHasNoMarginBottom
                        />
                        <RangeControl
                            label="Scroll Trigger Percentage : "
                            value={hfcScrollHeightPercentage}
                            onChange={handlehfcScrollHeightPercentageChange}
                            min={0}
                            max={100}
                            __nextHasNoMarginBottom
                        />
                    </>
                )}
                </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-popup'}>
              <div className='hfc-popup-inner'>
                <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    viewBox="0 0 384 512"
                    className="hfc-close-icon"
                    width="24"
                    height="24">
                    <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                </svg>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                />
             </div>
            </div>
        </div>
    );
}

export const save = ({ attributes }) => {
    const {
        id,
        hfcPopupPadding,
        hfcPopupInnerWidth,
        hfcPopupBGcolor,
        hfcPopupBtncolor,
        hfcPopupBtnHovercolor,
        hfcPopupDelayTime,
        hfcShowOnScroll,
        hfcPopupTriggerType,
        hfcScrollHeightPercentage,
    } = attributes;

    const hfcDynamicStyles = `
        #${id}.hfc-popup {
            visibility: hidden;
            opacity: 0;
            display: flex;
            align-items: center;
            height: 100vh;
            justify-content: center;
            position: fixed;
            transform: translate(-50%, -50%);
            left: 50%;
            top: 50%;
            z-index: 99999;
            width: 100vw;
            background-color: rgb(0 0 0 / 70%);
            transition: visibility 0.3s, opacity 0.3s;
        }
        #${id}.hfc-popup.is-visible {
            visibility: visible;
            opacity: 1;
        }
        #${id}.hfc-popup .hfc-popup-inner {
            position: relative;
            background-color: ${hfcPopupBGcolor};
            max-width: ${hfcPopupInnerWidth};
            width: 100%;
            margin: 10px;
            border-radius: 10px;
            box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        }
        #${id}.hfc-popup .hfc-close-icon {
            position: absolute;
            top: -10px;
            right: -10px;
            background: #000;
            padding: 5px;
            border-radius: 100px;
            fill: #ffffff;
            z-index: 1;
            cursor: pointer;
        }
        #${id}.hfc-popup .wp-block-media-text__media {
            background-color: #f7f7f7;
            border-radius: 10px 0px 0px 10px;
            overflow: hidden;
        }
        #${id}.hfc-popup .wp-block-media-text__content {
            padding: 50px ${hfcPopupPadding}px;
        }
        #${id}.hfc-popup .wp-block-media-text__media img{
            object-fit: contain!important;
        }
        #${id}.hfc-popup h2 {
            font-weight: bold;
            margin: 0px;
            padding: 10px 0px;
            font-size: 60px;
        }
        #${id}.hfc-popup p {
            margin: 0px;
            font-size: 18px;
            color: #434343;
            line-height: 24px;
        }
        #${id}.hfc-popup .hfc-popup-button {
            margin: 0px;
            padding-top: 20px;
        }
        #${id}.hfc-popup .hfc-popup-button .wp-block-button__link {
            border-radius: 10px;
            color: #fff;
            background-color: ${hfcPopupBtncolor};
            font-size: 18px;
            padding: 15px 30px;
            line-height: 24px;
            transition: 0.4s;
        }
        #${id}.hfc-popup .hfc-popup-button .wp-block-button__link:hover {
            border-radius: 10px;
            background-color: ${hfcPopupBtnHovercolor};
        }
        
        /* Responsive */
        @media (max-width: 599px) {
           #${id}.hfc-popup h2{
             font-size: 30px!important;
           }
        }
    `;
    const popupScript = `
    document.addEventListener('DOMContentLoaded', function () {
        const popup = document.getElementById('${id}');
        const closeIcon = popup.querySelector('.hfc-close-icon');
        
        // Generate keys based on trigger type
        const delayDismissKey = '${id}-dismissed-delay';
        const scrollDismissKey = '${id}-dismissed-scroll';

        // Reset dismissal states when the trigger type changes
        const resetDismissalState = () => {
            if ('${hfcPopupTriggerType}' === 'false') {
                localStorage.removeItem(scrollDismissKey);
            }
            if ('${hfcPopupTriggerType}' === 'true' && ${hfcShowOnScroll}) {
                localStorage.removeItem(delayDismissKey);
            }
        };

        resetDismissalState();

        const isPopupDismissed = () => {
            if ('${hfcPopupTriggerType}' === 'false') {
                return localStorage.getItem(delayDismissKey) === 'true';
            }
            if ('${hfcPopupTriggerType}' === 'true' && ${hfcShowOnScroll}) {
                return localStorage.getItem(scrollDismissKey) === 'true';
            }
            return false;
        };

        if (isPopupDismissed()) {
            return;
        }

        const showPopupOnDelay = () => {
            setTimeout(() => {
                popup.classList.add('is-visible');
            }, ${hfcPopupDelayTime});
        };

        const showPopupOnScroll = () => {
            window.addEventListener('scroll', function handleScroll() {
                const scrollPercentage = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
                if (scrollPercentage > ${hfcScrollHeightPercentage}) {
                    popup.classList.add('is-visible');
                    window.removeEventListener('scroll', handleScroll); // Prevent multiple triggers
                }
            });
        };

        if ('${hfcPopupTriggerType}' === 'false') {
            showPopupOnDelay();
        }

        if ('${hfcPopupTriggerType}' === 'true' && ${hfcShowOnScroll}) {
            showPopupOnScroll();
        }

        closeIcon.addEventListener('click', function () {
            popup.classList.remove('is-visible');
            if ('${hfcPopupTriggerType}' === 'false') {
                localStorage.setItem(delayDismissKey, 'true');
            }
            if ('${hfcPopupTriggerType}' === 'true' && ${hfcShowOnScroll}) {
                localStorage.setItem(scrollDismissKey, 'true');
            }
        });
    });
`;
    return (
        <>
            <RawHTML>{`<style>${hfcDynamicStyles}</style>`}</RawHTML>
            <RawHTML>{`<script>${popupScript}</script>`}</RawHTML>
            <div id={id} className="hfc-popup">
                <div className="hfc-popup-inner">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                        className="hfc-close-icon"
                        width="24"
                        height="24">
                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                    </svg>
                    <InnerBlocks.Content />
                </div>
            </div>
        </>
    );
};